// extracted by mini-css-extract-plugin
export default {"qr":"QR_qr__+A8rO","downloadBtn":"QR_downloadBtn__zAKi+"};